export const config = {
  BASE_URL: import.meta.env.VITE_BASE_URL as string,
  API_URL: import.meta.env.VITE_API_URL as string,
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL as string,
  ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL as string,
  AZURE_MAPS_BASE_URL: import.meta.env.VITE_AZURE_MAPS_BASE_URL as string,
  AZURE_MAPS_SUBSCRIPTION_KEY: import.meta.env
    .VITE_AZURE_MAPS_SUBSCRIPTION_KEY as string,
} as const;

export type Config = typeof config;
